

export class Viaje {

public  idCompania: string;
public  idUsuario: string;
public  idVehiculo: string;
public  idViaje: string;
public  fechaCreacion: Date;
public  fechaAsignacion: Date;
public  fechaSincronizacionMovil: Date;
public  fechaSincronizaacionNube: Date;
public  estado: string;



}